import React, { useState } from 'react'

export default ({ checked, additionalClasses, onClick }) => {
    const [isFocused, setIsFocused] = useState(false)

    return (
        // eslint-disable-next-line jsx-a11y/label-has-associated-control
        <label className={`checkbox ${additionalClasses}${checked ? ' active' : ''}${isFocused ? ' focused' : ''}`}>
            <input
                type="checkbox"
                checked={checked}
                onChange={onClick}
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
            />
        </label>
    )
}
